// src/utils/axios.secure.js
import axios from 'axios';

const apiBase =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  (process.env.NODE_ENV === 'development' ? '/api' : null) ||
  'https://ser.eyas-focus.o-r.kr/api';

// console.log('[axios] apiBase=', apiBase);//

const api = axios.create({
  baseURL: apiBase,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

let isRefreshing = false;
let waitQueue = [];

function enqueue(config) {
  return new Promise((resolve, reject) => waitQueue.push({ config, resolve, reject }));
}
function flushQueue(ok) {
  const q = waitQueue; waitQueue = [];
  q.forEach(({ config, resolve, reject }) => ok
    ? api.request(config).then(resolve).catch(reject)
    : reject(new Error('refresh failed')));
}
async function tryRefresh() {
  try {
    await api.post('/manager/user/token/refresh');
    return true;
  } catch { return false; }
}

api.interceptors.response.use(
  r => r,
  async err => {
    const status = err?.response?.status;
    const original = err?.config || {};

    const url = (original.url || '').toString();
    const isAuthPath = url.includes('/user/login') || url.includes('/token/refresh') || url.includes('/user/me');

    // 로그인/리프레시/ME 자체는 리프레시 시도 금지
    if (status === 401 && !isAuthPath && !original.__isRetryAfterRefresh) {
      if (!isRefreshing) {
        isRefreshing = true;
        const ok = await tryRefresh();
        isRefreshing = false;
        flushQueue(ok);
        if (!ok) {
          if (typeof window !== 'undefined') window.location.assign('/login');
          return Promise.reject(err);
        }
      }
      original.__isRetryAfterRefresh = true;
      return enqueue(original);
    }

    return Promise.reject(err);
  }
);

export default api;
